import {
  ACTIVE_MENU,
} from "../Types";


export const setActiveMenu = (payload) => {
  return{
    type: ACTIVE_MENU,
    payload: payload,
  }
}
